/**
 * Read payslip display values from API/DB fields only (no client-side payroll math).
 */

const emptyComponents = () => ({
  earnings: [],
  reimbursements: [],
  deductions: []
});

export const getPayslipViewData = (payslip) => {
  if (!payslip) {
    return {
      earnings: [],
      reimbursements: [],
      deductions: [],
      grossPay: 0,
      totalDeductions: 0,
      attendanceDeduction: 0,
      netPay: 0,
      proRatedGrossPay: 0,
      presentDays: 0,
      workingDays: 0,
      showProRataNote: false,
      showAttendanceDeductionRow: false,
      salaryStructure: null,
      monthlyComponents: emptyComponents(),
      incentive: 0
    };
  }

  const summary = payslip.proRatedSummary || {};
  const proRated = payslip.proRatedComponents || emptyComponents();
  const monthly = payslip.components || emptyComponents();

  const presentDays = summary.presentDays ?? payslip.presentDays ?? 0;
  const workingDays = summary.workingDays ?? payslip.workingDays ?? 0;
  const attendanceDeduction = Number(summary.attendanceDeduction ?? 0);

  return {
    earnings: proRated.earnings?.length ? proRated.earnings : monthly.earnings || [],
    reimbursements: proRated.reimbursements?.length ? proRated.reimbursements : monthly.reimbursements || [],
    deductions: proRated.deductions?.length ? proRated.deductions : monthly.deductions || [],
    grossPay: Number(summary.grossPay ?? payslip.proRatedGrossPay ?? 0),
    proRatedGrossPay: Number(payslip.proRatedGrossPay ?? summary.grossPay ?? 0),
    totalDeductions: Number(summary.totalDeductions ?? payslip.totalDeductions ?? 0),
    attendanceDeduction,
    netPay: Number(summary.netPay ?? payslip.netPay ?? 0),
    presentDays,
    workingDays,
    showProRataNote: workingDays > 0 && presentDays > 0 && presentDays !== workingDays,
    showAttendanceDeductionRow: attendanceDeduction > 0,
    salaryStructure: payslip.salaryStructure || null,
    monthlyComponents: monthly,
    incentive: Number(payslip.incentive || 0)
  };
};

export const formatInr = (amount) =>
  `₹${Number(amount || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
